import ProductVariantItem from 'snippets/product/product-variant/product-variant-item'

function ProductVariantList({ option, items, selected, setSelected, selectableValues }) {
  if (!items?.length) return null

  return (
    <>
      <p className="text-xs-medium uppercase text-neutral-900 lg:text-xs">{option}</p>
      <div className="mt-2.5 flex flex-wrap items-center gap-3">
        {items.map((item) => (
          <ProductVariantItem
            value={item}
            option={option}
            selected={selected}
            setSelected={setSelected}
            selectableValues={selectableValues}
          />
        ))}
      </div>
    </>
  )
}

export default ProductVariantList
